import React from "react";
import styles from "./header.module.css";

const Header = () => {
  return (
    <div className={styles.header}>
      {/* <img src="/icons/flow.svg" /> */}
      <img src="/icons/flow_logoNew.svg" alt="flow" />
    </div>
  );
};

export default React.memo(Header);
